/**
 * This is the checkbox command mixin for DFGrid
 */
import SelectionTracker from "common/framework/SelectionTracker";
import DFSelectionView from "./DFSelectionView";
import triStateUtil from "app/widgets/TriState/triStateUtil";
export default {

    _cleanupCheckBox: function() {
        if (this.selectionView) {
            this.selectionView.destroy();
            this.selectionViewElement.remove();
            delete this.selectionView;
            delete this.selectionViewElement;
        }
    },

    /**
     * Modify all the columns[].command = checkbox to have the actual implementation
     * @param options
     * @private
     */
    _configCheckBoxCommand: function(options) {
        if (options.columns) {
            for (var i = 0; i < options.columns.length; i++) {
                if (options.columns[i].command == "checkbox") {
                    this.checkboxField = options.checkboxField;
                    this.negateCheckboxField = options.negateCheckboxField;
                    if (options.negateCheckboxField) {
                        options.checkedCheckboxFieldValue = false;
                        options.uncheckedCheckboxFieldValue = true;
                    }
                    var headerAttributes = options.columns[i].headerAttributes;
                    options.columns[i] = {
                        headerTemplate: '<input type="checkbox" tabindex="-1" class="checkboxCommandHeader"/>',
                        headerAttributes: headerAttributes,
                        command: {
                            sortable: false,
                            filterable: false,
                            template: '<input type="checkbox" class="checkboxCommand" tabindex="-1" />'
                        },
                        filterable: false,
                        reorderable: false,
                        hidden: options.columns[i].hidden,
                        field: options.checkboxField || "checkbox",
                        width: 25,
                        menu: false
                    }
                } else if (options.columns[i].hidden == true && options.columns[i].groupHeaderTemplate != undefined && options.groupedCheckboxes == true) {
                    options.columns[i].groupHeaderTemplate = '<span><input tabindex="-1" type=\'checkbox\' class=\'checkboxGroup\'/>' + options.columns[i].groupHeaderTemplate + '</span>';
                }
            }
        }
    },

    _prepareCheckBox: function() {
        this._lastChecked = null;

        if (this.options.trackChecked && this.options.checkboxField) {
            this.checkTracker = new SelectionTracker({
                field: this.options.checkboxField,
                selectedValue: this.options.selectionViewValue || !this.options.negateCheckboxField,
                uniqueField: this.options.uniqueField
            });
            this.checkTracker.bindItem(this, "stoppedRefresh", "allowedRefresh");
            var me = this;
            this.checkTracker.bind("itemChange", function() {
                me.trigger("checkTrackerItemChange");
            });

            if (!this.options.hideSelectionView) {
                this.selectionViewElement = $("<div>")
                    .attr("id", this.element.attr("id") + "_selectionView")
                    .insertBefore(this.customPagerElement ? this.customPagerElement : this.wrapper);

                this.selectionView = new DFSelectionView(this.selectionViewElement, {
                    grid: this
                });
            }
        }
    },

    _preRefreshCheckboxes: function() {
        var me = this;
        this.thead.find("input[type='checkbox']")
            .off();

        this.tbody.find("input.checkboxCommand[type='checkbox']")
            .closest("td")
            .off();

        this.tbody.find("input.checkboxGroup[type='checkbox']")
            .off();

        this.tbody.off("mousedown", me._stopOnShiftClick);
        this._primaryColumn = this._findPrimaryColumn();
    },

    _stop: function(e) {
        e.stopPropagation();
    },

    _stopOnShiftClick: function(e) {
        if (e.shiftKey) {
            e.preventDefault();
        }
    },

    /**
     * Get the value for a checked row.
     * @private
     */
    _getCheckedState: function() {
        return this.options.checkedCheckboxFieldValue;
    },

    /**
     * Get the value for an unchecked row.
     * @private
     */
    _getUncheckedState: function() {
        return this.options.uncheckedCheckboxFieldValue;
    },

    /**
     * Get the value for a partially checked row.
     * @private
     */
    _getPartialState: function() {
        return this.options.partialCheckboxFieldValue;
    },

    /**
     * Get the state of item checkbox, after doing a little massaging to handle undefined/null, etc.
     * @private
     */
    _getItemCheckboxState: function(item) {
        var value = item[this.options.checkboxField];
        if (value !== this._getCheckedState() && value !== this._getUncheckedState() && value !== this._getPartialState()) {
            return !!value;
        } else {
            return value;
        }
    },

    /**
     * Set the row check state.
     * @private
     */
    _setRowCheckState: function(row, state) {
        var check = row.find("input[type=checkbox]");
        if (state == this._getCheckedState()) {
            triStateUtil.check(check, this._findPrimaryData(row));
            row.addClass("selected");
            return true;
        } else if (state == this._getUncheckedState()) {
            triStateUtil.uncheck(check, this._findPrimaryData(row));
            row.removeClass("selected");
            return false;
        } else {
            triStateUtil.partial(check);
            row.removeClass("selected");
            return false;
        }
    },

    /**
     * Convert the state returned by tri state, to one used by the grid internally.
     * @private
     */
    _convertTriStateToRowCheckState: function(state) {
        if (state === true) {
            return this._getCheckedState();
        } else if (state === false) {
            return this._getUncheckedState();
        } else {
            return this._getPartialState();
        }
    },

    /**
     * Get the next state that should be set.
     * @param row
     * @private
     */
    _rotateRowCheckState: function(row) {
        var next = triStateUtil.nextSetState(row.find("input[type=checkbox]"));
        return this._convertTriStateToRowCheckState(next);
    },

    /**
     * Get the last set state for a row checkbox.
     * @private
     */
    _getCurrentRowCheckState: function(row) {
        var last = triStateUtil.lastSetState(row.find("input[type=checkbox]"));
        return this._convertTriStateToRowCheckState(last);
    },

    /**
     * Getter/Setter for checkAll checkbox.
     * @private
     */
    _checkAllHeader: function(value) {
        var headerCheck = this.thead.find("input[type='checkbox']");
        if (value === true) {
            triStateUtil.check(headerCheck);
        } else if (value === false) {
            triStateUtil.uncheck(headerCheck);
        } else {
            return triStateUtil.lastSetState(headerCheck);
        }
    },

    /**
     * Getter/Setter for check state on a particular group row.
     * @private
     */
    _groupCheckboxHeader: function(selector, value) {
        var groupHeader = $(selector).find("input.checkboxGroup[type='checkbox']");
        if (value === true) {
            triStateUtil.check(groupHeader);
        } else if (value === false) {
            triStateUtil.uncheck(groupHeader);
        } else {
            return triStateUtil.lastSetState(groupHeader);
        }
    },

    _findPrimaryColumn() {
        const primary = this.options.columns.filter(col => !!col.primary);
        if(primary.length === 1) {
            return {field: primary[0].field, title: primary[0].title};
        } else {
            const columns = this.options.columns
                .filter(c => !c.command)
                .map(col => ({field: col.field, title: col.title}))
                .filter(f => !!f.field);
            const dataCounts = columns.map(f => new Set());
            this.dataSource.view().forEach(row => {
                columns.forEach(({field}, i) => {
                    if(row.get) {
                        dataCounts[i].add(row.get(field));
                    }
                });
            });
            return columns.reduce((best, column, i) => {
                const count = dataCounts[i].size;
                if(count > best.count) {
                    return {column, count}
                } else {
                    return best;
                }
            }, {column: {field: null, title: null}, count: -1}).column;
        }
    },

    _findPrimaryData(row) {
        return {
            label: this._primaryColumn.title,
            value: this.dataItem(row)?.get(this._primaryColumn.field)
        };
    },

    /**
     * Add all the event binding to the checkboxes
     * @private
     */
    _makeCheckBoxCommand: function() {
        var me = this;

        var changed = $.proxy(this._checkBoxClicked, this);
        var changeAll = function() {
            me.checkAll();
        };
        var changeGroup = $.proxy(this.checkGroup, this);

        // add the checkbox header
        var header = this.thead.find("input[type='checkbox']")
            .off()
            .on("click", changeAll)
            .on("mousedown", me._stop)
            .on("touchstart", me._stop)
            .on("selectstart", me._stop)
            .on("pointerdown", me._stop);
        this._checkAllHeader(false);

        var checks = this.tbody.find("input.checkboxCommand[type='checkbox']:not(.boundCheckbox)");

        // find the table cell that holds each checkbox and handle click selection, prevent propagation of other events.
        // this allows users to click anywhere in the cell without having to click the checkbox
        checks.closest("td")
            .off()
            .on("click", changed)
            .on("mousedown", me._stop)
            .on("touchstart", me._stop)
            .on("selectstart", me._stop)
            .on("pointerdown", me._stop);

        // find all checkboxes and handle click selection, prevent propagation of other events
        this.tbody.find("input.checkboxGroup[type='checkbox']")
            .off()
            .on("click", changeGroup)
            .on("mousedown", me._stop)
            .on("touchstart", me._stop)
            .on("selectstart", me._stop)
            .on("pointerdown", me._stop);

        // Prevent selection from occurring on Shift+Click; Needs to happen otherwise,
        // so users can select text from the grid.
        if (!me.options.selectable && (me.options.checkOnClick || me.options.rotateCheckOnClick)) {
            this.tbody.on("mousedown", me._stopOnShiftClick);
        }

        if (this.checkboxField) {
            var count = checks.length;
            var start = count;
            checks.each(function(i, c) {
                var check = $(c);
                var tr = check.closest("tr");
                var item = me.dataItem(tr);
                var itemChecked = me._getItemCheckboxState(item);
                var checked = me._setRowCheckState(tr, itemChecked);
                if (checked) {
                    count--;
                }

            });
            if (count == 0 && start > 0) {
                this._checkAllHeader(true);
            }

            if(!me.options.selectable && (me.options.checkOnClick || me.options.checkOnRightClick)){
                me.tbody.find("tr[data-uid]").on("click", function(e) {
                    var td = $(e.target).closest("td");
                    var row = $(e.currentTarget).closest("tr");
                    if (!td.hasClass("k-hierarchy-cell")) {
                        if (e.ctrlKey || e.metaKey) {
                            me.checkRow(row, me.CHECK_MODE.GROUP);
                        } else if (e.shiftKey) {
                            me.checkRow(row, me.CHECK_MODE.RANGE);
                        } else {
                            me.checkRow(row, me.CHECK_MODE.SINGLE);
                        }
                    }
                });
            }

            if (me.options.checkOnRightClick || (!me.options.selectable && me.options.checkOnClick)) {
                // right-click not checked treat like left-click
                me.tbody.find("tr[data-uid]").on("contextmenu", function(e) {
                    var row = $(e.currentTarget).closest("tr");
                    me.checkRow(row, me.CHECK_MODE.FORCE);
                });
            }
        }

        if (me.options.rotateCheckOnClick && !me.options.selectable) {
            me.tbody.find("tr[data-uid]").on("click", function(e) {
                var td = $(e.target).closest("td");
                var row = $(e.currentTarget).closest("tr");
                if (!td.hasClass("k-hierarchy-cell")) {
                    me.checkRow(row, e.shiftKey ? me.CHECK_MODE.ADD_RANGE : me.CHECK_MODE.GROUP);
                }
            });
        }

        if (this.options.groupedCheckboxes) {
            this._updateIndeterminate();
        }

        //mousedown,touchstart,selectstart stop table from selecting row when checkbox is clicked
        this._checkBoxChanged();
        this._checkComplete();
    },

    CHECK_MODE: {
        "SINGLE": "SINGLE",
        "GROUP": "GROUP",
        "FORCE": "FORCE",
        "RANGE": "RANGE",
        "ADD_RANGE": "ADD_RANGE"
    },

    /**
     * Handle keyboard interaction on grid.
     * @param row row
     * @param mode "SINGLE", "RANGE", "GROUP", "FORCE"
     * @param selector defaults to ".checkboxCommand"
     */
    checkRow: function(row, mode, selector) {
        var check = row.find(selector || ".checkboxCommand");
        if (check.length == 0) {
            return;
        }
        if (mode == this.CHECK_MODE.SINGLE) {
            // check this and only this row
            this._doCheckAll(false, false);
            this._forceCheckboxState(row, this._rotateRowCheckState(row));
            this._checkComplete();
        } else if (mode == this.CHECK_MODE.GROUP) {
            this._forceCheckboxState(row, this._rotateRowCheckState(row));
            this._checkComplete();
        } else if (mode == this.CHECK_MODE.FORCE) {
            // ensure that passed in row is checked. If it is, do nothing. If not, single select it
            if (this._getCurrentRowCheckState(row) !== this._getCheckedState()) {
                this.checkRow(row, this.CHECK_MODE.SINGLE, selector);
            }
        } else if (mode == this.CHECK_MODE.RANGE) {
            this.checkRange(this._firstCheckee(), row.attr("data-uid"), false);
        } else if (mode == this.CHECK_MODE.ADD_RANGE) {
            this.checkRange(this._firstCheckee(), row.attr("data-uid"), true);
        } else {
            throw new Error("Unknown mode: " + mode);
        }
    },

    _lastChecked: null,

    /**
     * Get last checked item, or first row, if none.
     * _lastChecked could have happened on UNcheck, but this is the same behavior Kendo uses
     * in selectable, so sticking with it, so behavior is consistent with ListView.
     *
     * @returns {*}
     * @private
     */
    _firstCheckee: function() {
        var checked;

        if (this._lastChecked !== null) {
            return this._lastChecked;
        }

        checked = this.checked();
        return checked.length > 0 ?
            $(checked[0]).attr("data-uid") :
            this.tbody.find("tr[data-uid]").eq(0).attr("data-uid");
    },

    /**
     * Check a range of table rows. Uses logic copied from kendo's selectable control,
     * but checking instead of selecting.
     *
     * @param startUid
     * @param endUid
     * @param ignoreOthers should other rows be unchecked
     */
    checkRange: function(startUid, endUid, ignoreOthers) {
        let idx;
        const items = this.tbody.find("tr[data-uid]");
        const start = items.filter(`[data-uid="${startUid}"]`).index();
        const end = items.filter(`[data-uid="${endUid}"]`).index();

        if (start == -1 || end == -1) {
            return;
        }

        if (!ignoreOthers) {
            this._doCheckAll(false, false);
        }

        // Need to check in the appropriate order, since every check triggers an update to
        // _lastChecked, which impacts the behavior of shift clicking.
        var checkedState = this._getCheckedState();
        if (start > end) {
            for (idx = end; idx <= start; idx++) {
                this._forceCheckboxState($(items[idx]), checkedState);
            }
        } else {
            for (idx = end; idx >= start; idx--) {
                this._forceCheckboxState($(items[idx]), checkedState);
            }
        }
        this._checkComplete();
    },

    rotateCheckbox(clickedTr) {
        const before = this.table.attr("aria-activedescendant");
        if(before) {
            //ensure keyboard navigation
            const checkbox = clickedTr.find(`#${before} input[type='checkbox']`);
            if(checkbox.length > 0) {
                const id = kendo.guid();
                clickedTr.find("input[type='checkbox']").attr("id", id);
                this.table.attr("aria-activedescendant", id);
            }
        }
        const now = this._rotateRowCheckState(clickedTr);
        this._forceCheckboxState(clickedTr, now);
        this._checkComplete();
    },

    /**
     * Handle a checkbox being clicked
     * @param e
     * @private
     */
    _checkBoxClicked: function(e) {
        e.stopPropagation();
        var clickedTr = $(e.target).closest("tr");
        if (e.shiftKey) {
            this.checkRow(clickedTr, this.CHECK_MODE.ADD_RANGE)
        } else {
            this.rotateCheckbox(clickedTr);
        }

        var td = $(e.target).closest("td");
        if (this.options.navigatable && td.length) {
            // Only change focus if the event was fired by an actual user click; do not change focus or keyboard
            // if triggered programmatically.
            if(e.originalEvent && e.originalEvent.isTrusted){
                this.current(td);
                this.focus();
            }
        }
    },

    /**
     * Force a checkbox into a particular state.
     *
     * This involves all parts, including firing events and updating headers.
     * This does nothing if the current state matches the forced state.
     * @private
     */
    _forceCheckboxState: function(row, state, skipBubble) {
        var current = this._getCurrentRowCheckState(row);
        if (current !== state) {
            var checkbox = row.find("input[type='checkbox']");
            if (checkbox.is(":enabled")) {
                var nowFullyChecked = this._setRowCheckState(row, state);
                this._checkBoxSync(row);

                if (!skipBubble) {
                    if (!nowFullyChecked) {
                        this._checkAllHeader(false);
                    }
                    if (this.options.groupedCheckboxes) {
                        this._bubbleIndeterminate(row);
                    }
                    if (nowFullyChecked) {
                        this._checkHeaderCheckbox();
                    }
                }

                this._lastChecked = row.attr("data-uid");
                this._checkBoxChanged(row);
                this._triggerUserChangeEvent(row, nowFullyChecked, false);
            }
        }
    },

    /**
     * Check whether the header checkbox should get checked. Call when the possibility exists that all checkboxes
     * have been checked, and the header checkbox needs to be updated.
     * @private
     */
    _checkHeaderCheckbox: function() {
        var allChecked = this.tbody.find("tr[data-uid] :checked").filter(function(i, el) {
            return !el.indeterminate
        }).length == this.tbody.find("tr[data-uid]").length;
        this._checkAllHeader(allChecked);
    },

    /**
     * Should be called whenever a checkbox has been changed.
     *
     * If publishing an individual row being checked, send through the checked row
     * @private
     */
    _checkBoxChanged: function(checkedRow) {
        this.trigger("checkChange", checkedRow);
        this.element.trigger("checkChange");
    },

    /**
     * Triggered when a check operation (1 or more check change events) is complete
     * @private
     */
    _checkComplete: function() {
        this.trigger("checkComplete");
    },

    /**
     * Should be called whenever the user changes the value of a checkbox.  Should not get called
     * during grid initializations.  Useful for dirty bindings / checks.
     * @private
     */
    _triggerUserChangeEvent: function(checkedRow, checked, checkAll) {

        var evt = {
            row: checkedRow,
            item: this.dataItem(checkedRow),
            checked: checked,
            single: !checkAll
        };


        this.trigger("userCheckChange", evt);
        this.element.trigger("userCheckChange", evt);

        if (this.options.selectable && this.options.selectOnCheck && !checkAll && checked) {
            this.select(checkedRow);
        }
    },

    /**
     * Should be called whenever a checkbox may have been changed.
     * @param checkbox
     * @private
     */
    _checkBoxSync: function(checkbox) {
        if (this.checkboxField) {
            this._haltRefresh = true;
            var tr = checkbox.closest("tr");
            var item = this.dataItem(tr);
            item.set(this.checkboxField, this._getCurrentRowCheckState(tr));
            this._haltRefresh = false;
        }
    },

    /**
     * Checks or Unchecks the header box as well as all row boxes.
     *
     * @param toggleTo Optional value that specifies state after toggle
     */
    checkAll: function(toggleTo) {
        this._doCheckAll(toggleTo, true);
    },

    /**
     * Internal implementation of check all.  Allows you to specifiy whether to send the checkChanged event
     * when clearing selection.
     *
     * @param toggleTo checked state
     * @param triggerCheckChangeEvent whether to send the check change event
     * @return {*}
     * @private
     */
    _doCheckAll: function(toggleTo, triggerCheckChangeEvent) {
        var me = this;
        if (toggleTo !== true && toggleTo !== false) {
            var last = this._checkAllHeader();
            toggleTo = !last;
        }

        var groupCheck = this.tbody.find("input[type=checkbox].checkboxGroup");
        var bodyCheckTr = this.tbody.find("input[type='checkbox']:not(.checkboxGroup)").closest("tr");

        var toState = toggleTo ? this._getCheckedState() : this._getUncheckedState();
        this._checkAllHeader(toggleTo);
        this._groupCheckboxHeader(".k-grouping-row", toggleTo);
        bodyCheckTr.each(function(i, el) {
            var row = $(el);
            me._setRowCheckState(row, toState);
            me._checkBoxSync(row.find("input[type=checkbox]"));
        });

        if (triggerCheckChangeEvent) {
            this._checkBoxChanged();
            this._checkComplete();
        }

        this.tbody.find("input[type=checkbox]").closest("tr").each(function(i, item) {
            me._triggerUserChangeEvent($(item), toggleTo, true);
        });
        return toggleTo;
    },

    /**
     * Handle a checkbox in a grouped row being checked.  Should check / uncheck all children of the group.
     * @param e
     */
    checkGroup: function(e) {
        e.stopPropagation();
        var groupRow = $(e.target).closest(".k-grouping-row");
        var last = this._groupCheckboxHeader(groupRow);
        var now = !last;
        this._groupCheckboxHeader(groupRow, now);
        var rowsInGroup = groupRow.nextUntil(".k-grouping-row").filter(":not(.k-detail-row)");

        if (now == false) {
            this._checkAllHeader(false);
        }

        var nextState = now ? this._getCheckedState() : this._getUncheckedState();

        var me = this;
        rowsInGroup.each(function(i, row) {
            me._forceCheckboxState($(row), nextState, true);
        });
        this._checkComplete();

        if (now == true) {
            this._checkHeaderCheckbox();
        }
    },

    /**
     * Returns all of the TR rows that are currently checked
     * @returns {*}
     */
    checked: function(checked) {
        var me = this;
        if (arguments.length > 0) {
            var el = $(checked);
            this._doCheckAll(false, false);
            var checkedState = me._getCheckedState();
            el.each(function(i, row) {
                me._forceCheckboxState($(row), checkedState);
            });
            this._checkComplete();
        }
        return this.tbody.find(":checked").filter(function(i, el) {
            return !el.indeterminate;
        }).closest("tr").toArray();
    },

    hasCheckedRows: function() {
        return this.checked().length > 0;
    },

    /**
     * Returns the number of rows checked
     */
    checkedCount: function() {
        return this.checked().length;
    },

    /**
     * Get all checked items across all pages - use this instead of grid.checkTracker.getSelected().
     * Note that this returns objects, not observables.
     *
     * @return {*}
     */
    getCheckedAllPages: function() {
        var me = this;
        if (this.checkTracker) {
            return this.checkTracker.getSelected();
        } else {
            return this.checked()
                .map(function(row) {
                    return me.dataItem($(row));
                })
                .filter(function(item) {
                    return !!item;
                });
        }
    },

    /**
     * Set the checked items across all pages.
     * @param items Array of observable items.  They don't necessarily have to have matching uids, but they should be observables.
     */
    setCheckedAllPages: function(items) {
        var me = this;
        var getItem = function(item) {
            var byUid = me.dataSource.getByUid(item.uid);
            if (byUid) {
                return byUid;
            } else {
                var byId = me.dataSource.get(item.id);
                if (byId) {
                    return byId;
                } else {
                    return item;
                }
            }
        };
        if (this.checkTracker) {
            me.checkTracker.reset();
            items
                .map(getItem)
                .forEach(function(item) {
                    me.checkTracker.forceChangeOfOne(item);
                });

        } else {
            var rows = items
                .map(function(item) {
                    return me.tbody.find("tr[data-uid='" + getItem(item).uid + "']");
                })
                .filter(function(match) {
                    return match.length == 1;
                })
                .map(function(el) {
                    return el[0];
                });
            this.checked($(rows));
        }
    },

    /**
     * Reset the check tracker.
     */
    resetCheckTracker: function() {
        if (this.checkTracker) {
            this.checkTracker.reset();
        }
    },

    /**
     * Returns an array of data-items or field-items when fname is specified.
     *
     * @param fname field-name (optional)
     * @returns {Array}
     */
    checkedItems: function(fname) {
        var me = this;

        var items = [];
        var item;
        var checked = me.checked();
        for (var i = 0; i < checked.length; i++) {
            item = me.dataItem(checked[i]);

            if (fname) {
                items.push(item.get(fname));
            } else {
                items.push(item);
            }
        }

        return items;
    },

    /**
     * Get the first checked row element.
     *
     * @return {*} first checked row element, or undefined when nothing checked
     */
    firstChecked: function() {
        var checkedEls = this.tbody.find("input.checkboxCommand[type='checkbox']:checked").filter(function(i, el) {
            return !el.indeterminate;
        });
        return (checkedEls.length) ? checkedEls.first().closest("tr") : undefined;
    },

    /**
     * Top-down update of initial indeterminate state for all nodes.
     * Called to set initial states of all category-level checkboxes.
     * @private
     */
    _updateIndeterminate: function() {
        var rows = this.tbody.find(".k-grouping-row");

        // Loops through all grouped header rows, checking the children for the header's state
        for (var i = 0; i < rows.length; i++) {
            this._setIndeterminate($(rows[i]));
        }
    },

    _setIndeterminate: function(groupRow) {
        var groupRowCheckbox = groupRow.find(".checkboxGroup");
        var groupRows = groupRow.nextUntil(".k-grouping-row");
        var areAllChecked = true;
        var areSomeChecked = false;
        var me = this;

        // Check all children of this group, to determine the state of the checkbox in the group's header
        groupRows.each(function(i, el) {
            if (!$(el).hasClass("k-detail-row")) {
                if (me._getCurrentRowCheckState($(el)) == me._getCheckedState()) {
                    areSomeChecked = true;
                } else {
                    areAllChecked = false;
                }
            }
        });
        // Update the group checkbox to either indeterminate or checked state, if needed
        if (areAllChecked && areSomeChecked) {
            triStateUtil.check(groupRowCheckbox);
        } else if (areSomeChecked) {
            triStateUtil.partial(groupRowCheckbox);
        } else {
            triStateUtil.uncheck(groupRowCheckbox);
        }
    },

    /**
     * Bottom-up setting of indeterminate state of parent nodes.
     * Called when clicking child checkboxes, to update state of parent checkbox.
     * @param row the TR element of the checkbox that was clicked
     * @private
     */
    _bubbleIndeterminate: function(row) {
        var previousRows = row.prevUntil(".k-grouping-row");
        // Get group header row, as previous element to last in previousRows element
        var groupHeaderRow = previousRows.length > 0 ? $(previousRows[previousRows.length - 1]).prev() : $(row).prev();
        this._setIndeterminate(groupHeaderRow);
    }

}
